var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{on:{"click":_vm.redirect}},[_vm._v("Redirect")]),_c('h2',{on:{"click":_vm.redirect2}},[_vm._v("Redirect2")]),_vm._v(" Hello World! "),_c('a',{attrs:{"href":"https://grocermate.ro/test-app"}},[_vm._v("Test 1")]),_vm._v(" "),_c('br'),_c('a',{attrs:{"href":"https://grocermate.ro/test-app","target":"_self"}},[_vm._v("Test 2")])])
}
var staticRenderFns = []

export { render, staticRenderFns }